import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const FieldIcon = withSvgIcon(
    <g>
        <path d="M415.6 451.5l17.1-241.3h-17.8l-47.8 241.3zM500 451.5l-15.1-241.3h-17.7l-15.1 241.3zM323.7 451.5l56.2-241.3h-19.3l-89.1 241.3zM332.5 223.8L0 210.4v40.7L325 238zM305.2 289.2L0 276.5v40.4l296.9-12.4zM282.8 353L0 340.9v40.2l273.7-11.8zM258.1 418.3L0 406.9v40l247.8-11zM399.2 194.3c0-80.6-65.3-145.9-145.9-145.9s-145.9 65.3-145.9 145.9h291.8z" />
    </g>
);
